<template>
    <div class="w-100">
        <confirm-box ref="error" :noConfirm="true"></confirm-box>
        <h6 v-if="id" class="col-12 text-primary">Editing {{ first }} {{ last }}</h6>
        <h6 v-else class="col-12 text-primary">Create new student</h6>
        <div class="row">
            <div class="col-12 mb-2 col-md-6 col-lg-4">
                <label for="first-name">First Name</label>
                <input v-model="first" type="text" class="form-control" placeholder="First Name" id="first-name"/>
            </div>
            <div class="col-12 mb-2 col-md-6 col-lg-4">
                <label for="last-name">Last Name</label>
                <input v-model="last" type="text" class="form-control" placeholder="Last Name" id="last-name"/>
            </div>
            <div class="col-12 mb-2 col-md-6 col-lg-2">
                <label for="number">Number</label>
                <input v-model="number" type="text" class="form-control" placeholder="00000" id="number"/>
            </div>
            <div class="col-6 mb-2 col-md-2 col-lg-2">
                <label for="grad-year">Grad</label>
                <input v-model="grad" type="number" class="form-control" placeholder="2030" if="grad-year"/>
            </div>
        </div>
        <cancel-submit-button class="mt-2"
            :submit-disabled="!submittable"
            @submit="id ? submit() : create()"
            @cancel="cancel"
        ></cancel-submit-button>
    </div>
</template>

<script>
import CancelSubmitButton from './CancelSubmitButton.vue';
import ConfirmBox from './ConfirmBox';

export default {
    components: { CancelSubmitButton, ConfirmBox },

    props: {
        district: {
            type: Number,
            default: null,
        },

        student: {
            type: Object,
            default(data={}) {
                return {
                    id: data.id ?? null,
                    number: data.number ?? '',
                    first_name: data.first_name ?? '',
                    last_name: data.last_name ?? '',
                    grad_year: data.grad_year ?? new Date().getFullYear() + 12
                }
            }
        },

        index: {
            type: Number,
            default: -1
        }
    },

    data() {
        return {
            id: this.student.id,
            number: this.student.number,
            first: this.student.first_name,
            last: this.student.last_name,
            grad: this.student.grad_year
        }
    },

    computed: {
        submittable: function() {
            return this.district !== null && Number(this.number);
        }
    },

    watch: {
        district: function (n, o) {
            this.cancel();
        }
    },

    methods: {
        cancel: function() {
            this.$parent.editing = -1;
        },

        submit: function() {
            let data = {
                first: this.first,
                last: this.last,
                number: this.number,
                grad: this.grad,
                number: this.number,
                district: this.district,
            };
            this.$parent.isLoading = true;
            axios
                .patch(`/api/admin/students/${this.id}`, data)
                .then((response) => {
                    console.log(response);
                    if (this.index != -1) {
                        this.$parent.students[this.index] = response.data;
                        this.$parent.editing = -1;
                    }
                })
                .catch((error) => {
                    if (error.response.status == 422) {
                        this.$refs.error.show({
                            title: 'Update Student Error',
                            content: error.response.data.message,
                            callback: () => {},
                        });
                    } else {
                        console.error(error);
                    }
                })
                .finally(() => {
                    this.$parent.isLoading = false;
                });
        },

        create: function() {
            let data = {
                first: this.first,
                last: this.last,
                grad: this.grad,
                number: this.number,
                district: this.district,
            };
            this.$parent.isLoading = true;
            axios
                .post('/api/admin/students', data)
                .then((response) => {
                    console.log(response);
                    this.id = null,
                    this.number = '',
                    this.first = '',
                    this.last = '',
                    this.grad = new Date().getFullYear() + 12
                })
                .catch((error) => {
                    if (error.response.status == 422) {
                        this.$refs.error.show({
                            title: 'Create Student Error',
                            content: error.response.data.message,
                            callback: () => {},
                        });
                    } else {
                        console.error(error);
                    }
                })
                .finally(() => {
                    this.$parent.isLoading = false;
                });
        }
    }


}
</script>